import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { getTokenUri } from '../../../../services/NFTMarketPlace/Graphquery'
import { INFTCardFormatted } from '../../components/NFTCard/INFTCard'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { IBaseNFTAttributes } from '../../models/INFTProperties'
import BaseCard from './BaseCard'
import { NFTFileFormatsEnum } from './DefaultCard'

export interface IGeneralCard {
  id: number
  name: string
  image: string
  description: string
  externalUrl: string
  attributes: IBaseNFTAttributes[]
}

export default function GeneralCard(props: INFTCardFormatted) {
  const { tokenId, collection } = props
  const [tokenUri, setTokenUri] = useState('')
  const [tokenItem, setTokenItem] = useState<IGeneralCard | null>(null)

  let tokenName = tokenItem && tokenItem.name ? tokenItem.name : collection.name

  if (tokenItem && !tokenItem.name) {
    tokenName = tokenItem ? `${collection.name} #${tokenId}` : collection.name
  }

  useEffect(() => {
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      getTokenUri(collection.tokenAddress, tokenId).then(res => setTokenUri(res))
    }
    if (tokenUri) {
      let newTokenUri = tokenUri
        .replace('ipfs://', 'https://ipfs.io/ipfs/')
        .replace('gateway.pinata.cloud', 'ipfs.io')
        .replace('https://gateway.pinata.cloud/ipfs/', '')
        .replace('http://', 'https://')

      if (collection.hash) {
        if (collection.endString) {
          newTokenUri = `https://ipfs.io/ipfs/${collection.hash}/${tokenId}.${collection.endString}`
        }
        else{
          newTokenUri = `https://ipfs.io/ipfs/${collection.hash}/${tokenId}`
        }
      }
      Api.get(newTokenUri).then((tokenResult: any) => setTokenItem(tokenResult))
    }
    if (collection.apiLink) {
      let newTokenUri = ''
      if (collection.endString) {
        newTokenUri = `${collection.apiLink}${tokenId}.${collection.endString}`
      }
      else{
        newTokenUri = `${collection.apiLink}${tokenId}`
      }
      
      Api.get(newTokenUri).then((tokenResult: any) => setTokenItem(tokenResult))
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  const mediaSource = tokenItem
    ? tokenItem?.image?.replace('ipfs://', 'https://ipfs.io/ipfs/').replace('gateway.pinata.cloud', 'ipfs.io')
    : ''

  function getImage() {
    let NFTItem
    if (collection.fileType === 'NFTFileFormatsEnum.VIDEO') {
      NFTItem = (
        <video controls={false} loop={true} controlsList="nodownload" muted={true} autoPlay={true} width="100%" src={mediaSource} />
      )
    } else if (collection.fileType === 'NFTFileFormatsEnum.AUDIO') {
      NFTItem = <video controls={true} controlsList="nodownload" width="100%" src={mediaSource} />
    } else if (collection.fileType === 'NFTFileFormatsEnum.IMAGE') {
      NFTItem = <img src={mediaSource} alt={tokenName} />
    } else {
      NFTItem = <img src={mediaSource} alt={tokenName} />
    }

    return <div className="default-image">{tokenItem ? NFTItem : <NFTImageSkeleton />}</div>
  }

  return (
    <BaseCard tokenName={tokenName} {...props}>
      {getImage()}
    </BaseCard>
  )
}
